import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import { B75, B400, N500, N80 } from '@atlaskit/theme/colors';
import { token, useThemeObserver } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoteActionsWrapper = styled.div({
	marginTop: token('space.100'),
	font: token('font.body.small'),
	display: 'flex',
	alignItems: 'baseline',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const ArchivePageActionLinkAnchor = styled.a<{
	color: string;
	isDisabled: boolean;
}>({
	flexShrink: 0,
	display: 'inline-block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	cursor: (props) => (props?.isDisabled ? 'default' : 'pointer'),
	fontWeight: token('font.weight.bold'),
	textDecoration: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	span: {
		/* Must override global, somewhat specific styles that make all links blue. span here targets the FormattedMessage inside the link */
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		color: (props) => props.color,
	},
	'&:hover': {
		textDecoration: 'none',
	},
});

export const ArchivePageActionLink: FC<React.ComponentProps<'a'> & { isDisabled?: boolean }> = ({
	isDisabled = false,
	onClick,
	children,
	...props
}) => {
	const theme = useThemeObserver();

	// During dark-mode tokenization in CCECO-700 we were unable to identify an appropriate
	// design-system token to use to represent this color in such a way that had sufficient
	// contrast with the background colors available in both light and dark modes. As a
	// result we're leaving this as custom for now but adding it as a request to our design
	// team to identify the best path forward for this color.

	const getColor = () => {
		if (theme.colorMode === 'dark') {
			return isDisabled ? N500 : B400;
		} else {
			return isDisabled ? N80 : B75;
		}
	};

	const onClickInternal = (event) => {
		if (!isDisabled) {
			onClick?.(event);
		}
	};

	return (
		<ArchivePageActionLinkAnchor
			color={getColor()}
			isDisabled={isDisabled}
			aria-disabled={isDisabled}
			onClick={onClickInternal}
			{...props}
		>
			{children}
		</ArchivePageActionLinkAnchor>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Spacer = styled.div({
	margin: `0 ${token('space.100')}`,
});
export const HorizontalSeparator = () => <Spacer>•</Spacer>;
